<template>
    <fieldset>
        <legend v-if="legend">{{Language.say('settings.layout.schemes')}}</legend>
        <div class="control-group">
            <ul class="control radio-group squared">
                <li v-for="(color, color_index) in colors"
                    :key="color_index"
                    :class="color">
                    <input
                        type="radio"
                        :id="color"
                        :checked="layout_controller.storage.color_scheme === `${color}-scheme`"
                        tabindex="-1">
                    <label
                        @click.prevent="onSetColor(`${color}-scheme`)"
                        :for="color"
                        tabindex="0">
                            {{Language.say(`settings.layout.schemes_colors.${color}`)}}
                    </label>
                </li>
            </ul>
        </div>
    </fieldset>
</template>

<script setup>
  import {defineProps} from 'vue';
  import Language from '@/js/Shared/Language/Language';

  const props = defineProps({
    layout_controller: Object,
    legend: {
      type: Boolean,
      default: true
    }
  })

  const colors = ['sapo', 'blue', 'orange', 'violet', 'red', 'green', 'pink', 'grey'];

  const onSetColor = (color) => {
    props.layout_controller.color_scheme = color;
  }
</script>